"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentToolOptions = exports.SubscriptionExtensionPackageStatus = exports.SubscriptionStatusEnum = exports.SubscriptionIntervalEnum = exports.SubscriptionOptionEnum = exports.SubscriptionLevelEnum = void 0;
var SubscriptionLevelEnum;
(function (SubscriptionLevelEnum) {
    SubscriptionLevelEnum["BASIC"] = "BASIC";
    SubscriptionLevelEnum["STARTER"] = "STARTER";
    SubscriptionLevelEnum["SCALE_UP"] = "SCALE_UP";
    SubscriptionLevelEnum["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionLevelEnum["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionLevelEnum = exports.SubscriptionLevelEnum || (exports.SubscriptionLevelEnum = {}));
var SubscriptionOptionEnum;
(function (SubscriptionOptionEnum) {
    SubscriptionOptionEnum["TOOLKIT"] = "TOOLKIT";
    SubscriptionOptionEnum["PAYMENTS_ONLY"] = "PAYMENTS_ONLY";
    SubscriptionOptionEnum["SHOPIFY_B2B_SUBSCRIPTION"] = "SHOPIFY_B2B_SUBSCRIPTION";
})(SubscriptionOptionEnum = exports.SubscriptionOptionEnum || (exports.SubscriptionOptionEnum = {}));
var SubscriptionIntervalEnum;
(function (SubscriptionIntervalEnum) {
    SubscriptionIntervalEnum["MONTH"] = "MONTH";
    SubscriptionIntervalEnum["YEAR"] = "YEAR";
})(SubscriptionIntervalEnum = exports.SubscriptionIntervalEnum || (exports.SubscriptionIntervalEnum = {}));
var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    //stripe statuses
    SubscriptionStatusEnum["active"] = "active";
    SubscriptionStatusEnum["past_due"] = "past_due";
    SubscriptionStatusEnum["unpaid"] = "unpaid";
    SubscriptionStatusEnum["canceled"] = "canceled";
    SubscriptionStatusEnum["incomplete"] = "incomplete";
    SubscriptionStatusEnum["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatusEnum["trialing"] = "trialing";
    SubscriptionStatusEnum["paused"] = "paused";
    // custom statuses
    SubscriptionStatusEnum["deleted"] = "deleted";
    SubscriptionStatusEnum["payment_action_required"] = "payment_action_required";
    SubscriptionStatusEnum["payment_failed"] = "payment_failed";
    SubscriptionStatusEnum["processing"] = "processing";
})(SubscriptionStatusEnum = exports.SubscriptionStatusEnum || (exports.SubscriptionStatusEnum = {}));
var SubscriptionExtensionPackageStatus;
(function (SubscriptionExtensionPackageStatus) {
    SubscriptionExtensionPackageStatus["PAID"] = "paid";
    SubscriptionExtensionPackageStatus["PENDING"] = "pending";
    SubscriptionExtensionPackageStatus["PAYMENT_FAILED"] = "payment_failed";
    SubscriptionExtensionPackageStatus["EXPIRED"] = "expired";
})(SubscriptionExtensionPackageStatus = exports.SubscriptionExtensionPackageStatus || (exports.SubscriptionExtensionPackageStatus = {}));
var PaymentToolOptions;
(function (PaymentToolOptions) {
    PaymentToolOptions["FENA"] = "fena";
    PaymentToolOptions["STRIPE"] = "stripe";
})(PaymentToolOptions = exports.PaymentToolOptions || (exports.PaymentToolOptions = {}));
